'use client';

import { useState, useEffect, useRef } from 'react';
import * as styles from './NavigationBar.module.css';
import { useMediaQuery } from '../../hooks/useMediaQuery';


export default function NavigationBar({ answeredQuestions, focusedQuestionIndex, setFocusedQuestionIndex }) {
  const reversedQuestions = [...answeredQuestions].reverse();

  return (
    <div className={styles.navigationBar}>
      <div className={styles.buttonGroup}>
        {reversedQuestions.map((question, i) => (
          <button
            key={question.id}
            className={`${styles.navKeywordButton} ${
              focusedQuestionIndex === answeredQuestions.length - 1 - i ? styles.active : ''
            }`}
            onClick={() => setFocusedQuestionIndex(answeredQuestions.length - 1 - i)}
          />
        ))}
      </div>
    </div>
  );
}